import { useContext, useEffect, useState } from "react";
import { Context } from "../../components/Context";
import { fetchData, GET_ALL_EVENTS_BY_CAT_ID, GET_CITY_BY_STATE_ID, GET_EVENTS_CATEGORIES } from "../../components/Service";
import { Link } from "../../../node_modules/react-router-dom/dist/index";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";
import Select from "react-select";

const Event = () => {
	const [list, setList] = useState([]);
	const [cat, setCat] = useState([]);
	const [context] = useContext(Context);
	const [defaultCatId, setDefaultCatId] = useState();
	const [cityId, setCityId] = useState();
	const [city, setCity] = useState([]);
	const [pageUrl, setPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);
	const [searchKeyword, setSearchKeyword] = useState();
	const [selectedCat, setSelectedCat] = useState();

	const getAllCategories = () => {
		fetchData(GET_EVENTS_CATEGORIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setCat(res?.data);
				setDefaultCatId(res?.data[0]?.id);
				setSelectedCat({ label: res?.data[0]?.name, value: res?.data[0]?.id });
			} else {
				setCat([]);
			}
		});
	};

	const getCity = (state_id) => {
		let payload = {
			state_id: [state_id],
		};

		fetchData(GET_CITY_BY_STATE_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setCity(res?.data);
			} else {
				setCity([]);
			}
		});
	};

	const getList = (country_id, state_id, catId) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
			category_id: catId,
		};

		if (searchKeyword) {
			payload = {
				...payload,
				keyword: searchKeyword,
			};
		}

		if (cityId) {
			payload = {
				...payload,
				city_id: cityId,
			};
		}

		fetchData(pageUrl ? pageUrl : GET_ALL_EVENTS_BY_CAT_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data?.data);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	const resetSearch = () => {
		setSearchKeyword("");
		setCityId();
	};

	useEffect(() => {
		if (context?.countryId && context?.stateId && defaultCatId) {
			setPageUrl();
			getList(context?.countryId, context?.stateId, defaultCatId);
		}
	}, [context?.stateId, defaultCatId]);

	useEffect(() => {
		scrollTop();
		if (context?.countryId && context?.stateId && defaultCatId) {
			getList(context?.countryId, context?.stateId, defaultCatId);
		}
	}, [pageUrl]);

	useEffect(() => {
		scrollTop();
		getAllCategories();
	}, []);

	useEffect(() => {
		if (context?.stateId) {
			getCity(context?.stateId);
		}
	}, [context?.stateId]);

	useEffect(() => {
		if (searchKeyword) {
			if (searchKeyword.length > 2) {
				getList(context?.countryId, context?.stateId, defaultCatId);
			}
		} else {
			if (context?.countryId && context?.stateId && defaultCatId) {
				getList(context?.countryId, context?.stateId, defaultCatId);
			}
		}
	}, [searchKeyword, cityId]);

	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 className="text-white d-flex mb-0 py-2">{context?.stateView ? "State Events" : "National Events"}</h4>
							</div>
							<div className="col-lg-9 ms-auto text-start text-lg-end ">
								<div className="input-group innersearch me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30">
									<input
										type="text"
										className="form-control py-1"
										placeholder="Search here..."
										name="keyword"
										onChange={(e) => setSearchKeyword(e.target.value)}
										value={searchKeyword}
										autoComplete="off"
									/>
								</div>

								{/* <select className="form-select height30 innersearch me-1 me-lg-0 ms-0 ms-lg-1 mb2px mt2px" onClick={(e) => setCityId(e.target.value)}>
									<option value="">All</option>
									{city?.length > 0 &&
										city?.map((item) => (
											<option key={item.id} value={item.id} selected={cityId == item.id}>
												{item.name}
											</option>
										))}
								</select> */}
								<button className="btn btn-light btn-find font13 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-2 px-lg-3 rounded-1 height30 mb2px mt2px" onClick={resetSearch}>
									<i className="fi fi-br-refresh "></i>
								</button>
								<Select
									options={cat?.map((item) => ({
										label: item.name,
										value: item.id,
									}))}
									value={selectedCat}
									onChange={(selected) => {
										setSelectedCat(selected);
										setDefaultCatId(selected?.value);
									}}
									placeholder="Select category"
									className={`selectpicker custom-react-select custom-react-select-w200 me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
									classNamePrefix="react-select"
								/>
								<button className="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px">Create Forums</button>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1 body-minh">
					<div className="row">
						{list?.data &&
							list?.data?.length > 0 &&
							list?.data?.map((item) => (
								<div key={item.id} className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 event_n mb-1">
									<div className="card-grid-2 hover-up h-100 mb-0">
										<Link to={`/events/${item.id}`}>
											<div className="ne-img-175">
												<img src={item.image ?? "/assets/images/no-image.jpg"} alt="..." />
											</div>
										</Link>
										<span className="stick">{item?.cat_id?.name}</span>
										<div className="card-block-info position-relative">
											<span className="view">
												<img src="/assets/images/icons/view.png" alt="..." /> {item.total_views}
											</span>
											<h6>
												<Link to={`/events/${item.id}`}>{item.title}</Link>
											</h6>
											<p className="color-text-paragraph mt-2">{item?.description}</p>
											<div className="card-2-bottom mt-30">
												<div className="row d-flex align-items-center">
													<div className="col-7 ">
														<img src="/assets/images/icons/cal.png" className="me-2" />
														<span className="text-muted">{item.created_at ? moment(item.created_at).format("DD-MMM-YYYY hh:mm a") : ""}</span>
													</div>
													<div className="col-5 ps-0 text-end">
														<Link to={`/events/${item.id}`} className="btn btn-apply-now font11">
															View More
														</Link>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							))}
						{notFound && <div className="text-center h6 text-danger py-3">No Records Found!</div>}
					</div>
					{list?.data && (
						<nav className="pt-3">
							<ul className="pagination justify-content-end">
								<li className={`page-item ${list.prev_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.prev_page_url)}>
										<span aria-hidden="true">&laquo;</span> Previous
									</button>
								</li>
								<li className={`page-item ${list.next_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.next_page_url)}>
										Next <span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			</div>
		</div>
	);
};

export default Event;
